import { combineReducers } from "redux";
import { gameInformation } from "../../v2/redux/reducers/GameInformation.reducer";
import { activity } from "../containers/Activity/Common/Activity.reducers";
import { autoplay } from "../containers/AutoplaySettings/Common/AutoplaySettings.reducers";
import { dialogs } from "../containers/Dialogs/Common/Dialogs.reducers";
import { footer } from "../containers/Footer/Common/Footer.reducers";
import { header } from "../containers/Header/Common/Header.reducers";
import { keypad } from "../containers/Keypad/Common/Keypad.reducers";
import { menu } from "../containers/Menu/Common/Menu.reducers";
import { theme } from "../containers/Theme/Common/Theme.reducers";
import { ticker } from "../containers/TickerDisplay/Common/TickerDisplay.reducers";
import { paytable } from "../../v2/redux/reducers/Paytable.reducer";
import { displayMode } from "../../v2/redux/reducers/DisplayMode.reducer";
import { view } from "../../v2/redux/reducers/View.reducer";
import { freeSpins } from "../../v2/redux/reducers/FreeSpins.reducer";
import { freeRounds } from "../../v2/redux/reducers/FreeRounds.reducer";
import { money } from "../../v2/redux/reducers/Money.reducer";
import { uiBlocker } from "../../v2/redux/reducers/UiBlocker.reducer";

export const rootReducer = combineReducers({
  keypad,
  menu,
  activity,
  autoplay,
  dialogs,
  ticker,
  header,
  footer,
  theme,
  money,
  gameInformation,
  paytable,
  displayMode,
  view,
  freeSpins,
  freeRounds,
  uiBlocker
});
